import { ISystemNotificationsResponse } from '../interfaces/notification.interfaces';
import { IVerifyContact } from '../interfaces/contact.interfaces';
import * as api from './middleware/api.middleware';
import { IMailBox, IAccess } from '../interfaces/mailbox.interfaces';
import { getMiddlewareOptionsWithContext } from './middleware/helpers';
import { ErrorContext } from '../enums';
import { build90DaysReminderNotification } from '../helpers/notification';
import { getObjDeepCopy } from '../helpers/general';
import { updateAccessNotificationSettings } from './mailbox.service';
import { staticConfig } from '../config/static';
import { store } from '../redux';
import { updateAccess } from '../redux/mailbox/actions';

const serviceUrl = '/notificationservice/v2';

export function getUnreadSystemNotifications(): Promise<ISystemNotificationsResponse> {
    const state = store.getState();
    const access: IAccess = state.mailbox.mailbox.access;
    const lastUpdatedAccess = new Date(access?.lastUpdated);
    const now = new Date();
    const notifications: ISystemNotificationsResponse = { itemCount: 0, items: [] };
    let expiryTime = null;
    let expiryDate = null;
    if (staticConfig.useTestExpiryTime) {
        expiryTime = now.setTime(now.getTime() - 1 * 60 * 1000);
        expiryDate = new Date(expiryTime);
    } else {
        expiryTime = now.setDate(now.getDate() - 90);
        expiryDate = new Date(expiryTime);
    }
    if (expiryDate > lastUpdatedAccess) {
        const ninetyDaysReminderNotification = build90DaysReminderNotification();
        notifications.items.push(ninetyDaysReminderNotification);
        const count = notifications.items.length;
        notifications.itemCount = count;
    }
    return Promise.resolve(notifications);
}

export function createSystemNotificationAcknowledge(systemNotificationId: number, userId: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        const state = store.getState();
        const mailbox: IMailBox = state.mailbox.mailbox;
        updateAccessNotificationSettings(mailbox.access, mailbox.id)
            .then((updatedAccess: IAccess) => {
                store.dispatch(updateAccess(getObjDeepCopy(updatedAccess)));
                resolve();
            })
            .catch((err) => {
                reject(err);
            });
    });
}

export function verifyContactDetail(
    mailboxId: string,
    accessId: string,
    subscriptionId: string,
    data: IVerifyContact,
    context?: ErrorContext
) {
    const verifyUrl = `${serviceUrl}/mailboxes/${mailboxId}/accesses/${accessId}/subscriptions/${subscriptionId}/verify`;
    return api.put<IAccess>(verifyUrl, data, null, getMiddlewareOptionsWithContext(context));
}
